export type LoginPromptModalOptions = {
  /** 登录成功后 `redirect` 参数，默认当前 path+search */
  nextUrl?: string;
};

type LoginPromptState = {
  open: boolean;
  nextUrl: string;
};

/** SSR / getServerSnapshot 固定快照，避免每次 new 对象 */
export const LOGIN_PROMPT_MODAL_SSR_SNAPSHOT: LoginPromptState = { open: false, nextUrl: '' };

let state: LoginPromptState = { ...LOGIN_PROMPT_MODAL_SSR_SNAPSHOT };

const listeners = new Set<() => void>();

function emit() {
  listeners.forEach(fn => fn());
}

export function subscribeLoginPromptModal(callback: () => void) {
  listeners.add(callback);
  return () => listeners.delete(callback);
}

export function getLoginPromptModalSnapshot(): LoginPromptState {
  return state;
}

function defaultNextUrl(): string {
  if (typeof window === 'undefined') return '';
  return window.location.href;
  // return `${window.location.pathname}${window.location.search}`;
}

/**
 * 打开登录提示弹窗（任意模块可直接调用）
 * @param options.nextUrl 登录页 `redirect`；不传则用当前地址
 */
export function showLoginModal(options?: LoginPromptModalOptions) {
  state = {
    open: true,
    nextUrl: options?.nextUrl ?? defaultNextUrl(),
  };
  emit();
}

export function hideLoginModal() {
  state = { ...state, open: false };
  emit();
}
